import React, { useState, useEffect } from "react";
import { FormCheck } from "react-bootstrap";
import { FormPreview } from "./FormPreview";
import { Card, Form, Alert } from "react-bootstrap";
import {
  FaTrash,
  FaEye,
  FaSave,
  FaArrowLeft,
  FaFont,
  FaAlignLeft,
  FaCalendarAlt,
  FaClock,
  FaCheck,
  FaList,
  FaCheckSquare,
  FaPalette,
  FaSlidersH,
  FaFile,
  FaEnvelope,
  FaPhone,
  FaLink,
  FaSearch,
  FaLock,
  FaPlus,
  FaCog,
  FaLayerGroup,
  FaUserCheck,
} from 'react-icons/fa'
import { Link } from "react-router-dom";

const FormCreator = ({
  formId,
  forms,
  onSave,
  onCancel,
  onPreview,
  updateForm,
  isEditMode = false,
  onGoback,
  formTypes,
  selectedFormType,
  setSelectedFormType,
}) => {
  console.log('FormCreator - formId:', formId)
  console.log('FormCreator - Is edit mode:', isEditMode)

  const EventID = localStorage.getItem('eventId') || ''
  const [formTitle, setFormTitle] = useState('')
  const [formType, setFormType] = useState('')
  const [formDescription, setFormDescription] = useState('')
  const [fields, setFields] = useState([])
  const [editMode, setEditMode] = useState('edit') // 'edit' or 'preview'
  const [selectedFieldId, setSelectedFieldId] = useState(null)
  const [isAmasiMemberForm, setIsAmasiMemberForm] = useState(false)
  // Find the current form
  const currentForm = forms.find((form) => form.id === formId)
  console.log('FormCreator - currentForm:', currentForm.id, formId, currentForm)
  console.log(editMode, 'editMode')

const updateAmasiField = (shouldAdd) => {
  const amasiField = {
    id: `field-${Date.now()}-amasimembership`,
    type: 'text',
    label: 'AMASI Membership Reg.email',
    name: 'amasimembership_number',
    placeholder: 'Enter your registered  email or phone no',
    required: true,
    helpText: '',
    isDefault: true,              
  };

  let updatedFields = [...fields];

  if (shouldAdd) {

    updatedFields = updatedFields.filter(
      (f) => f.name !== 'amasimembership_number'
    );


    updatedFields.unshift(amasiField);
  } else {

    updatedFields = updatedFields.filter(
      (f) => f.name !== 'amasimembership_number'
    );
  }

  setFields(updatedFields);
};


  const handleAmasiToggle = (e) => {
    const checked = e.target.checked
    setIsAmasiMemberForm(checked)
    updateAmasiField(checked)
  }

  useEffect(() => {
    console.log('FormCreator - useEffect - currentForm:', currentForm)
    if (currentForm) {
      setFormTitle(currentForm.form_title || '')
      setFormType(currentForm.form_type || '')
      setSelectedFormType(currentForm.form_type || '')
      setFormDescription(currentForm.form_description || '')


      setIsAmasiMemberForm(currentForm.member_form || false)

   
let loadedFields = currentForm.fields || [];


const defaultFields = [
  {
    id: `field-${Date.now()}-firstname`,
    type: 'text',
    label: 'First Name',
    name: 'first_name',
    placeholder: 'Enter your first name',
    required: true,
    helpText: '',
    isDefault: true,
  },
  {
    id: `field-${Date.now() + 1}-lastname`,
    type: 'text',
    name: 'last_name',
    label: 'Last Name',
    placeholder: 'Enter your last name',
    required: true,
    helpText: '',
    isDefault: true,
  },
  {
    id: `field-${Date.now() + 2}-email`,
    type: 'email',
    name: 'email_address',
    label: 'Email Address',
    placeholder: 'Enter your email address',
    required: true,
    helpText: '',
    isDefault: true,
  },
  {
    id: `field-${Date.now() + 3}-phone`,
    type: 'tel',
    name: 'phone_number',
    label: 'Phone Number',
    placeholder: 'Enter your phone number',
    required: true,
    helpText: '',
    isDefault: true,
  },
];


const hasDefaultFields = loadedFields.some(
  (f) => f.isDefault && f.name !== 'amasimembership_number'
);

if (!hasDefaultFields) {
  // Keep any existing AMASI field (it will be at index 0)
  const filtered = loadedFields.filter(
    (f) => !f.isDefault || f.name === 'amasimembership_number'
  );
  loadedFields = [...filtered, ...defaultFields];
}

if (currentForm.member_form) {
  const amasiField = {
    id: `field-${Date.now()}-amasimembership`,
    type: 'text',
    label: 'AMASI Membership Reg.email',
    name: 'amasimembership_number',
    placeholder: 'Enter your registered  email or phone no',
    required: true,
    helpText: '',
    isDefault: true,              
  };
  loadedFields = loadedFields.filter(
    (f) => f.name !== 'amasimembership_number'
  );
  loadedFields.unshift(amasiField);
}

setFields(loadedFields);
    }
  }, [currentForm, formId, forms])

  if (!currentForm) return <div>Form not found</div>

  // Field type categories
  const fieldCategories = [
    {
      id: 'text',
      name: 'Text Inputs',
      types: [
        { id: 'text', label: 'Text', icon: <FaFont size={14} /> },
        { id: 'email', label: 'Email', icon: <FaEnvelope size={14} /> },
        // { id: "password", label: "Password", icon: <FaLock size={14} /> },
        { id: 'number', label: 'Number', icon: <FaFont size={14} /> },
        { id: 'tel', label: 'Telephone', icon: <FaPhone size={14} /> },
        // { id: "url", label: "URL", icon: <FaLink size={14} /> },
        // { id: "search", label: "Search", icon: <FaSearch size={14} /> },
      ],
    },
    {
      id: 'date',
      name: 'Date & Time',
      types: [
        { id: 'date', label: 'Date', icon: <FaCalendarAlt size={14} /> },
        { id: 'time', label: 'Time', icon: <FaClock size={14} /> },
        {
          id: 'datetime-local',
          label: 'Date & Time',
          icon: <FaCalendarAlt size={14} />,
        },
        { id: 'month', label: 'Month', icon: <FaCalendarAlt size={14} /> },
        { id: 'week', label: 'Week', icon: <FaCalendarAlt size={14} /> },
      ],
    },
    {
      id: 'selection',
      name: 'Selection Inputs',
      types: [
        { id: 'select', label: 'Dropdown', icon: <FaList size={14} /> },
        {
          id: 'checkbox',
          label: 'Checkbox',
          icon: <FaCheckSquare size={14} />,
        },
        { id: 'radio', label: 'Radio Buttons', icon: <FaCheck size={14} /> },
        // { id: "datalist", label: "Datalist", icon: <FaList size={14} /> },
      ],
    },
    {
      id: 'special',
      name: 'Special Inputs',
      types: [
        { id: 'textarea', label: 'Text Area', icon: <FaAlignLeft size={14} /> },
        // { id: "color", label: "Color Picker", icon: <FaPalette size={14} /> },
        // { id: "range", label: "Range Slider", icon: <FaSlidersH size={14} /> },
        { id: 'file', label: 'File Upload', icon: <FaFile size={14} /> },
        // { id: "hidden", label: "Hidden Field", icon: <FaEye size={14} /> },
      ],
    },
  ]

  const addField = (type) => {
    const fieldLabel = `${type.charAt(0).toUpperCase() + type.slice(1)} `
    const newField = {
      id: `field-${Date.now()}`,
      type: type,
      label: fieldLabel,
      placeholder: `Enter ${type}`,
      required: false,
      helpText: '',
    }

    // Add options for select, radio, or checkbox
    if (['select', 'radio', 'checkbox'].includes(type)) {
      newField.options = ['Option 1', 'Option 2', 'Option 3']
    }

    // Add file input specific properties
    if (type === 'file') {
      newField.accept = ''
      newField.multiple = false
    }

    const updatedFields = [...fields, newField]
    setFields(updatedFields)
    setSelectedFieldId(newField.id)
  }

  const removeField = (id) => {
    const fieldToRemove = fields.find((field) => field.id === id)
    if (fieldToRemove && fieldToRemove.isDefault) {
      return
    }
    setFields(fields.filter((field) => field.id !== id))
    if (selectedFieldId === id) {
      setSelectedFieldId(null)
    }
  }
  const handleBack = () => {
    // setCurrent("list")
  }
  const saveForm = () => {
    const formData = {
      event_id: EventID,
      form_type: formType,
      form_title: formTitle,
      form_id: currentForm.form_id,
      form_description: formDescription,
      fields: fields,
      id: currentForm.id,
      member_form: isAmasiMemberForm,
    }

    console.log('FormCreator - Current Form ID:', currentForm.id)
    console.log('FormCreator - Saving form data:', formData)
    console.log('FormCreator - Is edit mode:', isEditMode)

    if (onSave) {
      onSave(formData)
    }
  }

  // Get the selected field
  const selectedField = fields.find((field) => field.id === selectedFieldId)

  // JSX Methods for better organization
  const renderHeader = () => (
    <div
      style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        borderBottom: '1px solid #e2e8f0',
        padding: '1.5rem 0',
        marginBottom: '2rem',
      }}
    >
      <div className="container-fluid">
        <div style={{ marginBottom: '22px' }}>
          <div className="brood_comes_div">
            <div className="row align-items-center">
              <div className="col-md-6 brood_comes_heading">
                <h2 className="mb-2">
                  <div className="brood_comes_part">
                    {/* <FaCheck /> */}
                    <i class="fa fa-table"></i>
                  </div>
                  Form Builder
                </h2>
                <nav aria-label="breadcrumb ">
                  <ol
                    style={{
                      display: 'flex',
                      listStyle: 'none',
                      padding: 0,
                      margin: 0,
                      fontSize: '0.875rem',
                      color: '#6b7280',
                    }}
                  >
                    <li
                      className="breadcrumb-item link_brood_comes"
                      style={{ cursor: 'pointer' }}
                      onClick={onGoback}
                    >
                      Dynamic Forms
                    </li>
                    <li style={{ marginInline: '0.5rem' }}> / </li>
                    <li>
                      {' '}
                      Forms{' '}
                      {editMode === 'preview'
                        ? 'Preview'
                        : isEditMode
                        ? 'Edit'
                        : 'Create'}
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="col-md-6 text-end">
                <button onClick={onGoback} className="btn btn-outline-primary ">
                  <FaArrowLeft />
                  Back to Forms
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="block-header">
          <div className="row clearfix">
            {/* <div className="col-md-6 col-sm-12">
              <h2
                style={{
                  color: "#1e293b",
                  fontWeight: "700",
                  marginBottom: "0.5rem",
                  fontSize: "1.75rem",
                }}
              >
                Form Builder
              </h2>
              <nav aria-label="breadcrumb">
                <ol
                  className="breadcrumb"
                  style={{
                    background: "transparent",
                    padding: 0,
                    margin: 0,
                    fontSize: "0.875rem",
                  }}
                >
                  <li className="breadcrumb-item" onClick={onGoback} style={{ cursor: "pointer" }}>
                    <Link
                      to="/events/admin/dynamic-forms"
                      style={{
                        color: "#64748b",
                        textDecoration: "none",
                        fontWeight: "500",
                      }}
                    >
                     
                    </Link>

                    Dynamic Forms
                  </li>
                  <li
                    className="breadcrumb-item active"
                    aria-current="page"
                    style={{
                      color: "#184778",
                      fontWeight: "600",
                    }}
                  >
                    Forms {editMode === "preview" ? "Preview" : isEditMode ? "Edit" : "Create"}

                  </li>
                </ol>
              </nav>
            </div> */}
            {/* <div className="col-md-6 col-sm-12">
              <div className="d-flex justify-content-end align-items-center gap-3">
                <button
                  onClick={onGoback}
                  style={{
                    background: "white",
                    border: "1px solid #d1d5db",
                    color: "#374151",
                    padding: "0.75rem 1.5rem",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    fontWeight: "500",
                    fontSize: "0.875rem",
                    transition: "all 0.2s ease",
                    boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#f9fafb";
                    e.target.style.borderColor = "#9ca3af";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "white";
                    e.target.style.borderColor = "#d1d5db";
                  }}
                >
                  <FaArrowLeft size={14} />
                  Back to Forms
                </button>
                <div
                  style={{
                    background: "white",
                    padding: "0.75rem 1.5rem",
                    borderRadius: "8px",
                    border: "1px solid #e2e8f0",
                    boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                  }}
                >
                  <span
                    style={{
                      color: "#64748b",
                      fontSize: "0.75rem",
                      fontWeight: "500",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                    }}
                  >
                    {isEditMode ? "Editing" : "Creating"}
                  </span>
                  <h3
                    style={{
                      color: "#1e293b",
                      fontSize: "1rem",
                      fontWeight: "600",
                      margin: "0.25rem 0 0 0",
                    }}
                  >
                    {formTitle || "Untitled Form"}
                  </h3>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )

  const renderModeToggle = () => (
    <div className="container-fluid" style={{ marginBottom: '2rem' }}>
      <div
        style={{
          background: 'white',
          padding: '0.5rem',
          borderRadius: '12px',
          border: '1px solid #e2e8f0',
          display: 'inline-flex',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
        }}
      >
        <button
          onClick={() => setEditMode('edit')}
          style={{
            background: editMode === 'edit' ? '#184778' : 'transparent',
            border: 'none',
            color: editMode === 'edit' ? 'white' : '#64748b',
            padding: '0.75rem 1.5rem',
            borderRadius: '8px',
            fontWeight: '600',
            fontSize: '0.875rem',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
          }}
        >
          <FaCog size={14} />
          Edit Form
        </button>
        <button
          onClick={() => setEditMode('preview')}
          style={{
            background: editMode === 'preview' ? '#184778' : 'transparent',
            border: 'none',
            color: editMode === 'preview' ? 'white' : '#64748b',
            padding: '0.75rem 1.5rem',
            borderRadius: '8px',
            fontWeight: '600',
            fontSize: '0.875rem',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
          }}
        >
          <FaEye size={14} />
          Preview Form
        </button>
      </div>
    </div>
  )

  const renderFieldTypesSidebar = () => (
    <div className="col-md-3">
      <div
        style={{
          background: 'white',
          borderRadius: '16px',
          border: '1px solid #e2e8f0',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
          overflow: 'hidden',
          marginBottom: '15px',
          position: 'sticky',
          top: '7pc',
        }}
      >
        <div
          style={{
            background: 'linear-gradient(270deg, #184778, #4964aa, #31719c)',
            padding: '1.5rem',
            color: 'white',
          }}
        >
          <div
            style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}
          >
            <FaLayerGroup size={14} />
            <h5 style={{ margin: 0, fontWeight: '600', fontSize: '1.125rem' }}>
              Field Types
            </h5>
          </div>
          {/* <p
            style={{
              margin: "0.5rem 0 0 0",
              fontSize: "0.875rem",
              opacity: 0.9,
            }}
          >
            Drag and drop to add fields
          </p> */}
        </div>
        <div className="total_form_fielsds" style={{ padding: '1.5rem' }}>
          {fieldCategories.map((category) => (
            <div key={category.id} style={{ marginBottom: '2rem' }}>
              <div
                style={{
                  color: '#64748b',
                  fontSize: '0.75rem',
                  fontWeight: '700',
                  marginBottom: '1rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.1em',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                }}
              >
                <div
                  style={{
                    width: '3px',
                    height: '12px',
                    background: '#184778',
                    borderRadius: '2px',
                  }}
                />
                {category.name}
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                {category.types.map((type) => (
                  <div
                    key={type.id}
                    onClick={() => addField(type.id)}
                    style={{
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.75rem',
                      padding: '10px',
                      width: '48%',
                      borderRadius: '10px',
                      border: '1px solid #f1f5f9',
                      background: '#fafbfc',
                      transition: 'all 0.2s ease',
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.background = '#f0f9ff'
                      e.currentTarget.style.borderColor = '#184778'
                      e.currentTarget.style.transform = 'translateY(-1px)'
                      e.currentTarget.style.boxShadow =
                        '0 4px 12px rgba(24, 71, 120, 0.15)'
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.background = '#fafbfc'
                      e.currentTarget.style.borderColor = '#f1f5f9'
                      e.currentTarget.style.transform = 'translateY(0)'
                      e.currentTarget.style.boxShadow = 'none'
                    }}
                  >
                    <div
                      style={{
                        color: '#184778',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '25px',
                        height: '25px',
                        background: 'white',
                        borderRadius: '8px',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                        flexWrap: 'wrap',
                      }}
                    >
                      {type.icon}
                    </div>
                    <span
                      style={{
                        color: '#1e293b',
                        fontSize: '12px',
                        fontWeight: '500',

                        flex: 1,
                      }}
                    >
                      {type.label}
                    </span>
                    <FaPlus
                      size={12}
                      style={{ color: '#94a3b8', opacity: 0.7 }}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )

  const renderFormSettings = () => (
    <div
      style={{
        background: 'white',
        borderRadius: '16px',
        border: '1px solid #e2e8f0',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        marginBottom: '15px',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
          padding: '1.5rem',
          borderBottom: '1px solid #e2e8f0',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <FaCog size={18} style={{ color: '#184778' }} />
          <h5
            style={{
              color: '#1e293b',
              fontWeight: '600',
              margin: 0,
              fontSize: '1.125rem',
            }}
          >
            Form Settings
          </h5>
        </div>
      </div>
      <div style={{ padding: '1.5rem' }}>
        <div style={{ marginBottom: '15px' }}>
          <label
            style={{
              color: '#374151',
              fontWeight: '600',
              marginBottom: '0.75rem',
              display: 'block',
              fontSize: '0.875rem',
            }}
          >
            Form Title
          </label>
          <input
            type="text"
            value={formTitle}
            onChange={(e) => setFormTitle(e.target.value)}
            placeholder="Enter form title"
            style={{
              width: '100%',
              border: '2px solid #e2e8f0',
              borderRadius: '10px',
              padding: '0.875rem 1rem',
              fontSize: '0.875rem',
              transition: 'all 0.2s ease',
              background: '#fafbfc',
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#184778'
              e.target.style.background = 'white'
              e.target.style.boxShadow = '0 0 0 3px rgba(24, 71, 120, 0.1)'
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#e2e8f0'
              e.target.style.background = '#fafbfc'
              e.target.style.boxShadow = 'none'
            }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label
            style={{
              color: '#374151',
              fontWeight: '600',
              marginBottom: '0.75rem',
              display: 'block',
              fontSize: '0.875rem',
            }}
          >
            Form Type
          </label>
          <select
            value={selectedFormType || formType}
            onChange={(e) => {
              const selectedName = e.target.value
              setSelectedFormType(selectedName)
              setFormType(selectedName)
            }}
            style={{
              width: '100%',
              border: '2px solid #e2e8f0',
              borderRadius: '10px',
              padding: '0.875rem 1rem',
              fontSize: '0.875rem',
              transition: 'all 0.2s ease',
              background: '#fafbfc',
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#184778'
              e.target.style.background = 'white'
              e.target.style.boxShadow = '0 0 0 3px rgba(24, 71, 120, 0.1)'
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#e2e8f0'
              e.target.style.background = '#fafbfc'
              e.target.style.boxShadow = 'none'
            }}
          >
            <option value="">Select a form type</option>
            {formTypes &&
              formTypes.map((form) => (
                <option key={form.id} value={form.name}>
                  {form.name}
                </option>
              ))}
          </select>
        </div>
        {/* New AMASI Member Form Checkbox */}
        <div style={{ marginBottom: '15px' }}>
          <label
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '0.75rem',
              cursor: 'pointer',
              padding: '1rem',
              background: '#f8fafc',
              borderRadius: '10px',
              border: '2px solid #e2e8f0',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.target.style.background = '#f0f9ff'
              e.target.style.borderColor = '#184778'
            }}
            onMouseOut={(e) => {
              e.target.style.background = '#f8fafc'
              e.target.style.borderColor = '#e2e8f0'
            }}
          >
            <input
              type="checkbox"
              checked={isAmasiMemberForm}
              onChange={handleAmasiToggle}
              style={{
                width: '18px',
                height: '18px',
                accentColor: '#184778',
                marginTop: '0.25rem',
              }}
            />
            <div>
              <span
                style={{
                  color: '#374151',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  display: 'block',
                }}
              >
                <FaUserCheck
                  size={14}
                  style={{ marginRight: '0.5rem', color: '#184778' }}
                />
                AMASI Member Form
              </span>
              <small
                style={{
                  color: '#64748b',
                  fontSize: '0.75rem',
                  display: 'block',
                  marginTop: '0.25rem',
                }}
              >
                If this is an AMASI member form
              </small>
            </div>
          </label>
        </div>
        <div>
          <label
            style={{
              color: '#374151',
              fontWeight: '600',
              marginBottom: '0.75rem',
              display: 'block',
              fontSize: '0.875rem',
            }}
          >
            Form Description
          </label>
          <textarea
            rows={3}
            value={formDescription}
            onChange={(e) => setFormDescription(e.target.value)}
            placeholder="Enter form description"
            style={{
              width: '100%',
              border: '2px solid #e2e8f0',
              borderRadius: '10px',
              padding: '0.875rem 1rem',
              fontSize: '0.875rem',
              transition: 'all 0.2s ease',
              background: '#fafbfc',
              resize: 'vertical',
              minHeight: '80px',
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#184778'
              e.target.style.background = 'white'
              e.target.style.boxShadow = '0 0 0 3px rgba(24, 71, 120, 0.1)'
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#e2e8f0'
              e.target.style.background = '#fafbfc'
              e.target.style.boxShadow = 'none'
            }}
          />
        </div>
      </div>
    </div>
  )

  const renderFormLayout = () => (
    <div
      style={{
        background: 'white',
        borderRadius: '16px',
        border: '1px solid #e2e8f0',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        marginBottom: '15px',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
          padding: '1.5rem',
          borderBottom: '1px solid #e2e8f0',
        }}
      >
        <h5
          style={{
            color: '#1e293b',
            fontWeight: '600',
            margin: '0 0 0.25rem 0',
            fontSize: '1.125rem',
          }}
        >
          Form Layout
        </h5>
        <p
          style={{
            color: '#64748b',
            fontSize: '0.875rem',
            margin: 0,
          }}
        >
          Click on a field to edit its properties
        </p>
      </div>
      <div style={{ padding: '1.5rem' }}>
        <div
          style={{
            background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
            border: '2px dashed #cbd5e1',
            borderRadius: '12px',
            padding: '15px',
            minHeight: '400px',
          }}
        >
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <h3
              style={{
                color: '#1e293b',
                fontSize: '1.5rem',
                fontWeight: '700',
                margin: '0 0 0.5rem 0',
              }}
            >
              {formTitle || 'Untitled Form'}
            </h3>
            {formDescription && (
              <p
                style={{
                  color: '#64748b',
                  fontSize: '0.875rem',
                  margin: 0,
                  maxWidth: '500px',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                {formDescription}
              </p>
            )}
          </div>

          {fields.length === 0 ? (
            <div
              style={{
                textAlign: 'center',
                padding: '3rem 1rem',
                color: '#94a3b8',
              }}
            >
              <FaLayerGroup
                size={48}
                style={{ marginBottom: '1rem', opacity: 0.5 }}
              />
              <p
                style={{
                  fontSize: '1.125rem',
                  fontWeight: '500',
                  margin: '0 0 0.5rem 0',
                }}
              >
                Your form is empty
              </p>
              <p style={{ fontSize: '0.875rem', margin: 0 }}>
                Add fields from the left sidebar to get started
              </p>
            </div>
          ) : (
            <div style={{ display: 'grid', gap: '1rem' }}>
              {fields.map((field) => (
                <div
                  key={field.id}
                  onClick={() => setSelectedFieldId(field.id)}
                  style={{
                    cursor: 'pointer',
                    padding: '1.25rem',
                    background:
                      selectedFieldId === field.id ? '#f0f9ff' : 'white',
                    border:
                      selectedFieldId === field.id
                        ? '2px solid #184778'
                        : '2px solid #e2e8f0',
                    borderRadius: '12px',
                    transition: 'all 0.2s ease',
                    position: 'relative',
                  }}
                  onMouseOver={(e) => {
                    if (selectedFieldId !== field.id) {
                      e.currentTarget.style.borderColor = '#cbd5e1'
                      e.currentTarget.style.transform = 'translateY(-1px)'
                      e.currentTarget.style.boxShadow =
                        '0 4px 12px rgba(0, 0, 0, 0.1)'
                    }
                  }}
                  onMouseOut={(e) => {
                    if (selectedFieldId !== field.id) {
                      e.currentTarget.style.borderColor = '#e2e8f0'
                      e.currentTarget.style.transform = 'translateY(0)'
                      e.currentTarget.style.boxShadow = 'none'
                    }
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <h6
                        style={{
                          color: '#1e293b',
                          fontSize: '1rem',
                          fontWeight: '600',
                          margin: '0 0 0.5rem 0',
                        }}
                      >
                        {field.label}
                      </h6>
                      <div
                        style={{
                          display: 'flex',
                          gap: '1rem',
                          alignItems: 'center',
                        }}
                      >
                        <span
                          style={{
                            color: '#64748b',
                            fontSize: '0.75rem',
                            background: '#f1f5f9',
                            padding: '0.25rem 0.75rem',
                            borderRadius: '20px',
                            fontWeight: '500',
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em',
                          }}
                        >
                          {field.type}
                        </span>
                        {field.required && (
                          <span
                            style={{
                              color: '#dc2626',
                              fontSize: '0.75rem',
                              background: '#fef2f2',
                              padding: '0.25rem 0.75rem',
                              borderRadius: '20px',
                              fontWeight: '500',
                            }}
                          >
                            Required
                          </span>
                        )}
                      </div>
                    </div>
                    {!field.isDefault && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation()
                          removeField(field.id)
                        }}
                        style={{
                          background: '#fef2f2',
                          border: '1px solid #fecaca',
                          color: '#dc2626',
                          padding: '0.5rem',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          transition: 'all 0.2s ease',
                        }}
                        onMouseOver={(e) => {
                          e.target.style.background = '#dc2626'
                          e.target.style.color = 'white'
                        }}
                        onMouseOut={(e) => {
                          e.target.style.background = '#fef2f2'
                          e.target.style.color = '#dc2626'
                        }}
                      >
                        <FaTrash size={14} />
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          <div
            style={{
              textAlign: 'center',
              marginTop: '2rem',
              paddingTop: '2rem',
              borderTop: '1px solid #e2e8f0',
            }}
          >
            {/* <button
              style={{
                background: "#184778",
                border: "none",
                color: "white",
                padding: "0.875rem 2rem",
                borderRadius: "10px",
                fontWeight: "600",
                fontSize: "0.875rem",
                cursor: "not-allowed",
                opacity: 0.7,
              }}
            >
              Submit Form
            </button> */}
          </div>
        </div>
      </div>
    </div>
  )

  const renderActionButtons = () => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '2rem',
        padding: '1.5rem',
        background: 'white',
        borderRadius: '16px',
        border: '1px solid #e2e8f0',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
      }}
    >
      <button onClick={onGoback} className="btn btn-outline-secondary ">
        Cancel
      </button>
      <div style={{ display: 'flex', gap: '1rem' }}>
        <button
          onClick={() => setEditMode('preview')}
          className="btn btn-outline-primary "
        >
          <FaEye size={16} />
          Preview Form
        </button>
        <button onClick={saveForm} className="btn btn-outline-primary ">
          <FaSave size={16} />
          {isEditMode ? 'Update Form' : 'Save Form'}
        </button>
      </div>
    </div>
  )

  const renderFieldProperties = () => (
    <div className="col-md-3">
      {selectedField ? (
        <div
          style={{
            background: 'white',
            borderRadius: '16px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
            position: 'sticky',
            top: '10pc',
          }}
        >
          <div
            style={{
              background: 'linear-gradient(270deg, #184778, #4964aa, #31719c)',
              padding: '1.5rem',
              color: 'white',
            }}
          >
            <div
              style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}
            >
              <FaCog size={18} />
              <h5
                style={{ margin: 0, fontWeight: '600', fontSize: '1.125rem' }}
              >
                Field Properties
              </h5>
            </div>
            <p
              style={{
                margin: '0.5rem 0 0 0',
                fontSize: '0.875rem',
                opacity: 0.9,
              }}
            >
              Customize selected field
            </p>
          </div>
          <div style={{ padding: '1.5rem' }}>
            <div style={{ marginBottom: '15px' }}>
              <label
                style={{
                  color: '#374151',
                  fontWeight: '600',
                  marginBottom: '10px',
                  display: 'block',
                  fontSize: '0.875rem',
                }}
              >
                Field Label
              </label>
              <input
                type="text"
                value={selectedField.label}
                onChange={(e) => {
                  const updatedFields = fields.map((f) =>
                    f.id === selectedField.id
                      ? { ...f, label: e.target.value }
                      : f
                  )
                  setFields(updatedFields)
                }}
                placeholder="Enter field label"
                style={{
                  width: '100%',
                  border: '2px solid #e2e8f0',
                  borderRadius: '10px',
                  padding: '10px 14px',
                  fontSize: '0.875rem',
                  transition: 'all 0.2s ease',
                  background: '#fafbfc',
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#184778'
                  e.target.style.background = 'white'
                  e.target.style.boxShadow = '0 0 0 3px rgba(24, 71, 120, 0.1)'
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#e2e8f0'
                  e.target.style.background = '#fafbfc'
                  e.target.style.boxShadow = 'none'
                }}
              />
            </div>

            {selectedField.type !== 'checkbox' &&
              selectedField.type !== 'hidden' && (
                <div style={{ marginBottom: '15px' }}>
                  <label
                    style={{
                      color: '#374151',
                      fontWeight: '600',
                      marginBottom: '0.75rem',
                      display: 'block',
                      fontSize: '0.875rem',
                    }}
                  >
                    Placeholder Text
                  </label>
                  <input
                    type="text"
                    value={selectedField.placeholder || ''}
                    onChange={(e) => {
                      const updatedFields = fields.map((f) =>
                        f.id === selectedField.id
                          ? { ...f, placeholder: e.target.value }
                          : f
                      )
                      setFields(updatedFields)
                    }}
                    placeholder="Enter placeholder text"
                    style={{
                      width: '100%',
                      border: '2px solid #e2e8f0',
                      borderRadius: '10px',
                      padding: '0.875rem 1rem',
                      fontSize: '0.875rem',
                      transition: 'all 0.2s ease',
                      background: '#fafbfc',
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#184778'
                      e.target.style.background = 'white'
                      e.target.style.boxShadow =
                        '0 0 0 3px rgba(24, 71, 120, 0.1)'
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e2e8f0'
                      e.target.style.background = '#fafbfc'
                      e.target.style.boxShadow = 'none'
                    }}
                  />
                </div>
              )}

            {['select', 'radio', 'checkbox'].includes(selectedField.type) &&
              selectedField.options && (
                <div style={{ marginBottom: '15px' }}>
                  <label
                    style={{
                      color: '#374151',
                      fontWeight: '600',
                      marginBottom: '0.75rem',
                      display: 'block',
                      fontSize: '0.875rem',
                    }}
                  >
                    Options (comma separated)
                  </label>
                  <textarea
                    rows={3}
                    value={selectedField.options
                      .map((opt) =>
                        typeof opt === 'object'
                          ? `${opt.label}:${opt.value}`
                          : opt
                      )
                      .join(', ')}
                    onChange={(e) => {
                      const optionsText = e.target.value.trim()
                      let newOptions
                      if (optionsText.includes(':')) {
                        newOptions = optionsText.split(',').map((option) => {
                          const parts = option.trim().split(':')
                          if (parts.length === 2) {
                            return {
                              label: parts[0].trim(),
                              value: parts[1].trim(),
                            }
                          }
                          return option.trim()
                        })
                      } else {
                        newOptions = optionsText
                          ? optionsText
                              .split(',')
                              .map((option) => option.trim())
                          : []
                      }
                      const updatedFields = fields.map((f) =>
                        f.id === selectedField.id
                          ? { ...f, options: newOptions }
                          : f
                      )
                      setFields(updatedFields)
                    }}
                    placeholder="Option 1, Option 2, Option 3"
                    style={{
                      width: '100%',
                      border: '2px solid #e2e8f0',
                      borderRadius: '10px',
                      padding: '0.875rem 1rem',
                      fontSize: '0.875rem',
                      transition: 'all 0.2s ease',
                      background: '#fafbfc',
                      resize: 'vertical',
                      minHeight: '80px',
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#184778'
                      e.target.style.background = 'white'
                      e.target.style.boxShadow =
                        '0 0 0 3px rgba(24, 71, 120, 0.1)'
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e2e8f0'
                      e.target.style.background = '#fafbfc'
                      e.target.style.boxShadow = 'none'
                    }}
                  />
                  <small
                    style={{
                      color: '#64748b',
                      fontSize: '0.75rem',
                      marginTop: '0.5rem',
                      display: 'block',
                    }}
                  >
                    You can use Label:Value format (e.g., "Sports:sports_id,
                    Music:music_id") to set different values.
                  </small>
                </div>
              )}

            <div style={{ marginBottom: '15px' }}>
              <label
                style={{
                  color: '#374151',
                  fontWeight: '600',
                  marginBottom: '0.75rem',
                  display: 'block',
                  fontSize: '0.875rem',
                }}
              >
                Help Text
              </label>
              <input
                type="text"
                value={selectedField.helpText || ''}
                onChange={(e) => {
                  const updatedFields = fields.map((f) =>
                    f.id === selectedField.id
                      ? { ...f, helpText: e.target.value }
                      : f
                  )
                  setFields(updatedFields)
                }}
                placeholder="Enter help text"
                style={{
                  width: '100%',
                  border: '2px solid #e2e8f0',
                  borderRadius: '10px',
                  padding: '0.875rem 1rem',
                  fontSize: '0.875rem',
                  transition: 'all 0.2s ease',
                  background: '#fafbfc',
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#184778'
                  e.target.style.background = 'white'
                  e.target.style.boxShadow = '0 0 0 3px rgba(24, 71, 120, 0.1)'
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#e2e8f0'
                  e.target.style.background = '#fafbfc'
                  e.target.style.boxShadow = 'none'
                }}
              />
              <small
                style={{
                  color: '#64748b',
                  fontSize: '0.75rem',
                  marginTop: '0.5rem',
                  display: 'block',
                }}
              >
                Additional information to help users understand this field
              </small>
            </div>

            {selectedField.type === 'file' && (
              <>
                <div style={{ marginBottom: '15px' }}>
                  <label
                    style={{
                      color: '#374151',
                      fontWeight: '600',
                      marginBottom: '0.75rem',
                      display: 'block',
                      fontSize: '0.875rem',
                    }}
                  >
                    Accepted File Types
                  </label>
                  <input
                    type="text"
                    value={selectedField.accept || ''}
                    onChange={(e) => {
                      const updatedFields = fields.map((f) =>
                        f.id === selectedField.id
                          ? { ...f, accept: e.target.value }
                          : f
                      )
                      setFields(updatedFields)
                    }}
                    placeholder=".pdf,.jpg,.png"
                    style={{
                      width: '100%',
                      border: '2px solid #e2e8f0',
                      borderRadius: '10px',
                      padding: '0.875rem 1rem',
                      fontSize: '0.875rem',
                      transition: 'all 0.2s ease',
                      background: '#fafbfc',
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#184778'
                      e.target.style.background = 'white'
                      e.target.style.boxShadow =
                        '0 0 0 3px rgba(24, 71, 120, 0.1)'
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e2e8f0'
                      e.target.style.background = '#fafbfc'
                      e.target.style.boxShadow = 'none'
                    }}
                  />
                  <small
                    style={{
                      color: '#64748b',
                      fontSize: '0.75rem',
                      marginTop: '0.5rem',
                      display: 'block',
                    }}
                  >
                    Comma-separated list of file extensions or MIME types
                  </small>
                </div>
                <div style={{ marginBottom: '15px' }}>
                  <label
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.75rem',
                      cursor: 'pointer',
                      padding: '1rem',
                      background: '#f8fafc',
                      borderRadius: '10px',
                      border: '2px solid #e2e8f0',
                      transition: 'all 0.2s ease',
                    }}
                    onMouseOver={(e) => {
                      e.target.style.background = '#f0f9ff'
                      e.target.style.borderColor = '#184778'
                    }}
                    onMouseOut={(e) => {
                      e.target.style.background = '#f8fafc'
                      e.target.style.borderColor = '#e2e8f0'
                    }}
                  >
                    <input
                      type="checkbox"
                      id="field-multiple-edit"
                      checked={selectedField.multiple || false}
                      onChange={(e) => {
                        const updatedFields = fields.map((f) =>
                          f.id === selectedField.id
                            ? { ...f, multiple: e.target.checked }
                            : f
                        )
                        setFields(updatedFields)
                      }}
                      style={{
                        width: '18px',
                        height: '18px',
                        accentColor: '#184778',
                      }}
                    />
                    <span
                      style={{
                        color: '#374151',
                        fontSize: '0.875rem',
                        fontWeight: '500',
                      }}
                    >
                      Allow multiple file selection
                    </span>
                  </label>
                </div>
              </>
            )}

            <div style={{ marginBottom: '15px' }}>
              <label
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  cursor: 'pointer',
                  padding: '1rem',
                  background: '#f8fafc',
                  borderRadius: '10px',
                  border: '2px solid #e2e8f0',
                  transition: 'all 0.2s ease',
                }}
                onMouseOver={(e) => {
                  e.target.style.background = '#f0f9ff'
                  e.target.style.borderColor = '#184778'
                }}
                onMouseOut={(e) => {
                  e.target.style.background = '#f8fafc'
                  e.target.style.borderColor = '#e2e8f0'
                }}
              >
                <input
                  type="checkbox"
                  id="checkbox-required"
                  checked={selectedField.required || false}
                  onChange={(e) => {
                    const updatedFields = fields.map((f) =>
                      f.id === selectedField.id
                        ? { ...f, required: e.target.checked }
                        : f
                    )
                    setFields(updatedFields)
                  }}
                  style={{
                    width: '18px',
                    height: '18px',
                    accentColor: '#184778',
                  }}
                />
                <span
                  style={{
                    color: '#374151',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                  }}
                >
                  Required Field
                </span>
              </label>
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            background: 'white',
            borderRadius: '16px',
            border: '2px dashed #cbd5e1',
            padding: '3rem 2rem',
            textAlign: 'center',
            position: 'sticky',
            top: '10pc',
          }}
        >
          <FaCog size={48} style={{ color: '#cbd5e1', marginBottom: '1rem' }} />
          <p
            style={{
              color: '#94a3b8',
              fontSize: '1rem',
              fontWeight: '500',
              margin: '0 0 0.5rem 0',
            }}
          >
            No field selected
          </p>
          <p
            style={{
              color: '#cbd5e1',
              fontSize: '0.875rem',
              margin: 0,
            }}
          >
            Click on a field to edit its properties
          </p>
        </div>
      )}
    </div>
  )

  const renderPreviewMode = () => (
    <div
      style={{
        background: 'white',
        borderRadius: '16px',
        border: '1px solid #e2e8f0',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
          padding: '1.5rem',
          borderBottom: '1px solid #e2e8f0',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <FaEye size={18} style={{ color: '#184778' }} />
          <h5
            style={{
              color: '#1e293b',
              fontWeight: '600',
              margin: 0,
              fontSize: '1.125rem',
            }}
          >
            Form Preview
          </h5>
        </div>
      </div>
      <div style={{ padding: '1.5rem' }}>
        <FormPreview
          title={formTitle}
          description={formDescription}
          fields={fields}
        />
      </div>
      <div
        style={{
          background: '#f8fafc',
          padding: '1.5rem',
          borderTop: '1px solid #e2e8f0',
        }}
      >
        <button
          type="button"
          onClick={() => setEditMode('edit')}
          className="btn btn-outline-primary "
        >
          <FaArrowLeft />
          Back to Editor
        </button>
      </div>
    </div>
  )

  return (
    <>
      {renderHeader()}
      {renderModeToggle()}
      {editMode === 'edit' ? (
        <div className="container-fluid">
          <div className="row dynamic_form">
            {renderFieldTypesSidebar()}
            <div className="col-md-6">
              {renderFormSettings()}
              {renderFormLayout()}
              {renderActionButtons()}
            </div>
            {renderFieldProperties()}
          </div>
        </div>
      ) : (
        renderPreviewMode()
      )}
    </>
  )
};

export default FormCreator;